export default "__VITE_ASSET__BrA5wpXj__"